import { useInView } from '../hooks/useInView';

const quotes = [
  { text:"Justice is not only created in courts or by lawyers, but also by ordinary people who try to solve problems in their communities. Even as students we can contribute to improving justice in our own surroundings.", tag:"On justice" },
  { text:"These 3 days were the most valuable experience, more than 3 years of college gave me. It gave me confidence and interest to participate in more work like this.", tag:"On impact" },
  { text:"Earlier I thought justice was only about courts and laws, but now I realize it is also about fairness in society and that small ideas and teamwork can bring real change.", tag:"On perspective" },
  { text:"The river of life activity reflected how far I've come and made me think, what next? It summarised my life and made me nostalgic about my past and how much I've grown.", tag:"On self-reflection" },
  { text:"Not every workshop is Q&A based. This one was about how you interact with people, how you make them feel seen and included. That's what I'm taking away.", tag:"On learning methods" },
];

export default function StudentVoices() {
  const [ref, inView] = useInView({ threshold:0.08 });
  return (
    <section id="voices" className="section-dark">
      <div className="container" ref={ref}>

        <div className={`reveal ${inView?'visible':''}`} style={{ marginBottom:'3.5rem' }}>
          <p style={{ fontFamily:'var(--font-head)', fontSize:'0.65rem', fontWeight:700, letterSpacing:'0.2em', textTransform:'uppercase', color:'var(--accent)', marginBottom:'0.75rem', display:'flex', alignItems:'center', gap:'8px' }}>
            <span style={{ display:'block', width:20, height:2.5, background:'var(--accent)' }} />
            Student Voices
          </p>
          <h2 className="h2 h2-white">In their<br />own words</h2>
        </div>

        {/* Featured quote */}
        <div className={`reveal ${inView?'visible':''}`} style={{ marginBottom:'1.5rem', transitionDelay:'0.08s', padding:'2.5rem', border:'2.5px solid var(--accent)', borderRadius:4, boxShadow:'5px 5px 0px var(--accent)', background:'#111' }}>
          <div style={{ fontFamily:'var(--font-head)', fontSize:'4rem', color:'var(--accent)', lineHeight:0.8, marginBottom:'1rem', fontWeight:700 }}>"</div>
          <p style={{ fontFamily:'var(--font-body)', fontSize:'1.2rem', color:'#E5E5E5', lineHeight:1.75, fontStyle:'italic', marginBottom:'1.25rem' }}>
            I realised that we as law students hold so much power to bring change. A single person can be the change.
          </p>
          <span className="tag tag-accent">On agency</span>
        </div>

        {/* Grid */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(260px, 1fr))', gap:'1.25rem' }}>
          {quotes.map((q, i) => (
            <div key={i} className={`reveal ${inView?'visible':''}`} style={{
              transitionDelay:`${(i+1)*0.08}s`,
              padding:'2rem', background:'#111',
              border:'2.5px solid #262626', borderRadius:4,
            }}>
              <div style={{ fontFamily:'var(--font-head)', fontSize:'2.5rem', color:'var(--accent)', lineHeight:0.8, marginBottom:'1rem', fontWeight:700 }}>"</div>
              <p style={{ fontFamily:'var(--font-body)', fontSize:'0.92rem', color:'#CCCCCC', lineHeight:1.75, fontStyle:'italic', marginBottom:'1rem' }}>{q.text}</p>
              <span className="tag" style={{ background:'transparent', borderColor:'#333', color:'#666', fontSize:'0.55rem' }}>{q.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
